export default {
	insert: {
		id: 'IDを入力します',
		pw: 'パスワードを入力します',
	},

	find: {
		id: 'ID検索',
		pw: 'パスワード検索',
	},

	filter: {
		filter: 'フィルタ',
		all: 'すべて',
		add: '追加',
		delete: '削除',
		modify: '修正',
	},

	header: {
		alarm: {
			allRead: 'すべて既読',
			noAlarm: '新しい通知はありません。',
			leftComment: '{name}さんがコメントを残しました。',
			leftSignatureRequest: '{name}さんが署名をリクエストしました。',
			signatureRequest: '{name}さんが署名をリクエストしました。',
			time: '今日',
			yesterday: '昨日',
			minutesAgo: '{n}分前',
			hoursAgo: '{n}時間前',
			daysAgo: '{n}日前',
			avatarAlt: 'プロフィール画像',
			timeAgo: '時間前',
			dayAgo: '日前',
			weekAgo: '週前',
			monthAgo: '月前',
			yearAgo: '年前',
		},
	},

	modal: {
		title: '警鐘',
		message: '本当に削除してもよろしいですか?	',
		serverError: 'エラーが発生しました。しばらくしてからもう一度お試しください。',
		signature: {
			title: '署名',
			upload: 'アップロード',
			draw: '描画',
			uploadDescription: 'ファイルをドラッグアンドドロップするか、ファイルを選択するボタンを使用して直接ファイルを選択してください',
			selectFile: 'ファイルを選択',
			drawDescription: '署名をここに入力してください',
			reset: 'リセット',
			undo: '元に戻す',
			redo: 'やり直し',
			save: '保存',
			close: '閉じる',
			invalidExtension: '無効なファイル拡張子です。 画像ファイルのみアップロードできます。',
			multipleFiles: '1つのファイルのみアップロードできます。',
		},
		fileUpload: {
			noFile: 'アップロードされたファイルが存在しません。もう一度お試しください。',
			noExtension: 'ファイル拡張子を再度確認してください。',
			noFileName: 'ファイル名が見つかりませんでした。もう一度お試しください。',
			sizeExceeded: 'ファイルサイズが1MBを超えています。1MB以下のファイルをアップロードしてください。',
		},
		save: '保存が完了しました。',
		signatureCancel: '署名がキャンセルされました。',
		block: 'ブロックを選択してください。',
		file: 'ファイルを選択してください。',
		date: '日付を選択してください。',
		select: '選択してください。',
		retry: '後ほど再試行してください。',
		projectList: {
			terminate: 'プロジェクトが終了しました。',
			delete: '現在のプロジェクトのノートが削除されました。',
			create: 'プロジェクトが作成されました。',
			createError: 'ノート作成中にエラーが発生しました。',
			saveOut: '保存されていない内容があります。\n保存されていない内容は失われます。\n保存しますか？',
			save: '内容が保存されました。',
			title: 'プロジェクト名を記入してください',
			participant: '参加者を指定してください。',
			approver: '承認者を指定してください。',
			viewer: 'Viewerを指定してください。',
			createProject: 'プロジェクトが作成されました。',
			update: 'プロジェクトが修正されました。',
			errDefault: 'プロジェクト作成中にエラーが発生しました。\n 再試行してください。',
			errDuplicate: 'プロジェクト研究ノート名の重複エラーです。',
			errNoteDelete: 'ノート参加者はプロジェクト参加者から除外できません。',
			msgTerminate: '本当に終了しますか?',
			errProjectUpdate: 'プロジェクト修正中にエラーが発生しました。\n 再試行してください。',
			errFileOver: 'ファイルのアップロードは100個まで可能です',
			errFileOverSize: 'ファイルのアップロードは10GBまで可能です',
		},

		templateList: {
			create: 'テンプレートが作成されました。',
			createError: 'ノート作成中にエラーが発生しました。\n 再試行してください。',
			saveOut: '保存されていない変更があります。\n保存されていない変更は失われます。\n保存しますか?',
			save: 'コンテンツが保存されました。',
			delete: 'テンプレートを削除しますか?',
			title: 'テンプレート名を入力してください。',
			participant: '参加者を指定してください。',
			approver: '承認者を指定してください。',
			viewer: '閲覧者を指定してください。',
			update: 'テンプレートが修正されました。',
			errDuplicate: 'テンプレート名重複エラーです。',
			errDefault: 'テンプレート作成中にエラーが発生しました。\n 再試行してください。',
			msgTerminate: '本当に終了しますか?',
			templateLeaderRequired: 'テンプレートリーダーを選択してください。',
		},

		uploadImg: '3MB以下の画像のみアップロードできます。',
		uploadFile: '50MB以下のファイルのみアップロードできます。',
		selectFile: 'JPG、JPEG、PNG、GIFファイルのみ選択してください。',
		selectFileExtension: 'xls,xlsx,pptx,pdf,docx,txt,zip,rar,tar,odtファイルのみ選択してください。',
		optionList: {
			chart: {
				type: '種類',
				create: 'チャート作成',
				labelName: 'ラベル名は必須です。',
				dataName: 'データ名は必須です。',
				negativeWarn: '負の値ではチャートを作成できません。',
				auto: '自動',
				data: 'データ',
				x: 'X軸のラベル名は必須です。',
				y: 'Y軸のラベル名は必須です。',
				color: '色',
				horizontal: '横',
				vertical: '縦',
				title: 'チャート名',
				warn: 'チャート名を入力してください。',
				placeholderList: {
					y: 'Y軸のラベル名を入力してください。',
					x: 'X軸のラベル名を入力してください',
					data: 'データ名',
					label: 'ラベル名',
				},
				noTable: '現在、チャートを作成するためのテーブルが存在しません。',
				select: 'チャートを作成するには、まずテーブルを選択してください。',
				multi: 'チャートを作成するには、単一の範囲ではなく複数の範囲を指定する必要があります。',
			},
			date: {
				warn: '現在選択されているブロックには日付を追加できません。',
			},
		},
		position: '位置を再指定してください。',
		range: '現在選択されている文字には日付を追加できません。 範囲を変更してください。',
		dropbox: {
			enterText: 'コードと名前を少なくとも1つ入力してください。',
			emptyCode: '番目のコードが空です。',
			emptyName: '番目の名前が空です。',
			sameCode: '同じコードは使用できません。',
		},
		schema: {
			required: 'field と valueは必須です。',
			enterTxt: 'スキーマは必須入力です。',
			emptyField: '番目のスキーマのフィールドが空です。',
			emptyValue: '番目のスキーマの値が空です。',
			emptyName: '番目のスキーマの名前が空です。',
			sameName: '同じスキーマ名は使用できません。',
		},
		template: {
			create: 'テンプレートが正常に作成されました。',
			version: '承認が完了しました。',
			verWarn: 'このバージョンは承認できません。',
			approve: 'テンプレートを承認',
			approveConfirm: 'テンプレートを承認しますか?',
			approveNeedSave: '未保存の変更があります。承認する前に保存してください。',
			tempData: '現在、仮保存されたデータがあります。',
			delete: '削除後に承認しますか?',
			deleteAlarm: 'テンプレート削除中にエラーが発生しました。',
			saveErrorMessage: 'テンプレートの保存中にエラーが発生しました。',
		},
		user: {
			email: '有効なメールアドレスを入力してください。',
			phone: '有効な電話番号を入力してください。',
			modifyInfo: '情報が更新されました。',
		},
		myPage: {
			name: '名前',
			email: 'メールアドレス',
			phone: '電話番号',
			department: '部署',
			placeholder: {
				name: '名前を入力してください。',
				phone: '電話番号を入力してください。',
				email: 'メールアドレスを入力してください。',
			},
			required: '名前を入力してください。',
		},
		session: {
			autoLogout: (minute: number | null | undefined) => `${!minute ? '1分' : minute + '秒'}後に自動ログアウトされます。ログイン維持時間の延長を希望する場合は、延長ボタンを押してください。`,
			autoLogoutTerminate: 'ログアウトされました。 再度ログインしてください。',
			terminate: 'セッションが終了しました。',
		},
		searchResult: '該当する結果が見つかりませんでした。',
		error: {
			title: 'トエラー',
			template: 'テンプレートエラー',
			project: 'プロジェクトエラー',
			department: '部署エラー',
			minimumLength: '2文字以上入力してください。',
			searchError: '検索中にエラーが発生しました。',
			participant: '参加者の一覧取得中にエラーが発生しました。',
			list: 'データの一覧取得中にエラーが発生しました。',
			user: 'ユーザーの一覧取得中にエラーが発生しました。',
			departmentSearch: '部署の一覧取得中にエラーが発生しました。',
			priority: '優先順位の一覧取得中にエラーが発生しました。',
			schema: 'スキーマの一覧取得中にエラーが発生しました。',
			schemaCreate: 'スキーマの作成中にエラーが発生しました。',
			schemaSave: 'スキーマの保存中にエラーが発生しました。',
			signature: '署名 一覧取得中にエラーが発生しました。',
			signatureUpload: '署名 アップロード中にエラーが発生しました。',
			signatureCancel: '署名 キャンセル中にエラーが発生しました。',
			signatureComplete: '署名 完了 ホルスにエラーが発生しました。',
			noSignature: '署名がありません。署名を追加してください。',
			noteSave: 'ノートの保存中にエラーが発生しました。',
			logout: 'ログアウトに失敗しました。 もう一度お試しください。',
			searchType: '検索タイプを選択してください。',
			userUpdate: 'ユーザー権限の保存中にエラーが発生しました。',
			licenseUpdate: 'ライセンスの更新中にエラーが発生しました。',
			schemaListType: 'スキーマタイプ名は必須です。',
			dropbox: 'ドロップボックスの一覧取得中にエラーが発生しました。',
			projectCloseAlarm: 'プロジェクトのすべてのノートが終了されている必要があります。',
			projectOpenAlarm: '現在、このプロジェクトは進行中です。再開は、ステータスが「終了」の場合にのみ可能です。',
			projectCloseServerError: '終了処理中にエラーが発生しました。',
			projectOpenServerError: '再開処理中にエラーが発生しました。',
			emptyTitle: 'タイトルは必須です。',
			duplicateTitle: 'タイトルが重複しています。',
			htmlTag: 'HTMLタグを含めることはできません。',
			reviewFind: 'リビューの検索中にエラーが発生しました。',
			projectLeaderFind: 'プロジェクトリーダーの情報取得中にエラーが発生しました。',
			note: 'ノートの読み込み中にエラーが発生しました。',
			noteUid: 'ノート UIDがありません。',
			userInfo: 'ユーザー情報がありません。',
			dateRange: '開始日を終了日より前に設定してください。',
			downloadError: 'ダウンロード中にエラーが発生しました。',
			roleNotFound: (roleName: string) => `権限 ${roleName}をroleListから見つけることができません。`,
			templateDeleteAlarm: 'テンプレート削除中にエラーが発生しました。',
			templateApprove: 'テンプレートスキーマの保存中にエラーが発生しました。',
			templateListRetrieve: 'リストの読み込みに失敗しました。',
			blockTypeFile: 'ファイルはテキストブロックのみ追加できます。',
			blockTypeImage: '画像はテキストブロックのみ追加できます。',
			blockTypeTable: 'テーブルはテキストブロックのみ追加できます。',
			blockTypeCalendar: '日付はテキストブロックのみ追加できます。',
			blockTypeChart: 'チャートはテーブルブロックのみ追加できます。',
			latexEmpty: '空の値は保存できません。',
		},
		preview: 'プレビュー',
		projectCloseAlarm: 'プロジェクトのすべてのノートが終了されている必要があります。',
		success: {
			userUpdate: 'ユーザー権限の保存が完了しました。',
			licenseUpdate: 'ライセンスの更新が完了しました。',
			signatureRequest: '署名要求が送信されました。',
			downloadSuccess: 'ダウンロードが完了しました。',
		},
		noChange: '変更がありません。',
		licenseRevoke: 'ライセンスを解約しますか?',
	},

	menu: {
		dashboard: 'ダッシュボード',
		project: 'プロジェクト',
		template: 'テンプレート',
		schema: 'スキーマ',
		dropbox: 'ドロップボックス',
	},

	sign: {
		in: 'ログイン',
		up: 'サインアップ',
		find: {
			id: 'ID検索',
			pw: 'パスワード検索',
		},
		id: 'ID(E-mail)',
		pw: 'パスワード',
		rePw: 'パスワードの確認',
		save: 'セーブID',
		out: 'サインアウト',
		hide: 'パスワード 数隠す',
		show: 'パスワード 数表示',
		ing: 'ログイン中。。。',
		checkList: {
			input: 'IDとパスワードを入力してください。',
			retry: 'もう一度ログインを試してください。',
			email: '登録済みのメールアドレスを入力してください。',
		},
		err: {
			employee: '従業員検索エラーが発生しました。 再試行してください。',
			token: 'トークン発行エラーが発生しました。 再試行してください。',
			login_fall: 'ログインに失敗しました。 アイデンティティとパスワードを確認してください。',
			server_failure: 'サーバーの問題によりログインに失敗しました。',
		},
		service: {
			terms: 'サービス 利用規約',
			privacy: '個人情報 処理方針',
		},
	},

	user: {
		id: 'ユーザーID',
	},

	note: {
		closed: { success: 'ノートが終了しました。' },
		signature: { success: 'ノートの署名が完了しました。', revoke: 'ノートの署名が解除されました。', error: 'ノートの署名解除に失敗しました。' },
		create: { success: 'ノートが作成されました。', existstitle: { failure: 'ノート名は既に存在します。' } },
		save: { success: 'ノートが保存されました。' },
		update: { success: 'ノートが修正されました。', notinprogress: { failure: '署名進行中のノートは修正できません。' } },
		retrieve: { notexists: { failure: 'ノートが存在しません。' } },
		allComplete: 'ノートの署名が完了しました。',
	},

	designation: '様',

	dashboard: {
		info: 'こんにちは。',
		project: '企画する',
		joinProject: '進行中のプロジェクト',
		template: 'テンプレート',
		schema: 'スキーマ',
		dropbox: 'ドロップボックス',
		endableProject: '終了可能プロジェクト',
		closedProject: '終了したプロジェクト',
		item: '件',
		asset: 'Asset',
	},

	table: {
		thumbnail: 'サムネイル',
		no: '番号',
		priority: '優先順位',
		title: '題目',
		userNm: '名前',
		userId: 'ID',
		code: 'Code',
		email: 'Email',
		phone: '携帯電話番号',
		poster: '登録者',
		updatedUserId: '編集者',
		createDt: '登録日',
		updateDt: '修正日',
		loginDt: '最近のログイン',
		version: 'バージョン',
		more: 'もっと見る',
		status: '状態',
		description: '説明',
		statusCodeI: '進行',
		statusCodeF: '完了',
		statusCodeY: '使用',
		statusCodeN: '未使用',
		actionType: 'アクション',
		none: '結果なし',
		content: '現在、データが登録されていません',
		signatureList: '署名リスト',
		endDay: '締切日',
		dropboxTitle: 'タイトル',
		required: '必須',
		uniqueValue: '固有値',
		name: '名前',
		basic: '基本',
		use: '使用',
		unUse: '未使用',
		type: 'タイプ',
		create: 'テーブル作成',
		createError: 'テーブル作成時に最低1行/列を指定する必要があります。',
		createMaxError: 'テーブル作成時に最大30行/列まで作成できます。',
		addMaxError: 'テーブルには最大100行/列まで追加できます。',
		department: '部署',
		userCreateDt: '登録日',
		revokeDt: '解約日',
		renewDt: '更新日',
		expireDt: '有効期限',
		schemaCellSizeError: 'セルのサイズが追加しようとしているスキーマのサイズより小さいです。\nセルを増やしてスキーマを追加してください。',
		schemaDeleteConfirm: 'スキーマを含む行があります。\n続行するとスキーマ行も一緒に削除されます。\n続行しますか？',
	},

	department: {
		detail: {
			user: 'ユーザー情報',
			info: '詳細情報',
			role: '権限リスト',
			default: 'デフォルト権限',
		},
		group: {
			info: 'グループメンバー',
			select: '部署を選択してください',
			groupName: 'グループ名',
			groupLeader: 'グループリーダー',
			groupMember: 'グループメンバー',
			groupMemberSelect: 'グループメンバーを選択してください',
			name: '名前(ID)',
		},
		modal: {
			updateSuccess: '部署情報の更新に成功しました。',
			updateFailure: '部署情報の更新に失敗しました。',
		},
	},

	search: {
		select: '選択',
		placeholder: '検索ワードを入力してください。',
		search: '照会',
		total: '合計',
		new: '新規作成',
		type: 'タイプ選択',
		year: '年',
		month: '月',
		day: '日',
		startDate: '開始日',
		endDate: '終了日',
		createDate: '登録順',
		modifyDate: '修正順',
		desc: '降順',
		asc: '昇順',
		clear: '全て削除',
		close: '閉じる',
		pageSizeList: {
			10: '10件',
			20: '20件',
			50: '50件',
			100: '100件',
		},
		typeList: {
			unknownUser: '名前なし',
			title: '警鐘',
			userId: '登録者',
			description: '説明',
			type: 'タイプ名',
			status: '状態',
			name: 'なまえ',
			id: 'ID',
			role: '権限',
			employee: '社員番号',
			email: 'Email',
			phone: '携帯電話番号',
			department: '部署名',
			executives: '役職員名',
			noteName: '研究ノート名',
		},
		placeholderList: {
			department: '部門名を入力します。',
			participate: '参加研究者を入力します。',
			date: '日付を入力してください。',
			type: 'タイプを指定してください。',
			select: '部署名または役職者名を選択してください。',
			version: 'バージョンを指定してください。',
			label: '名前を入力してください。',
			unique: '固有値を入力してください。',
			basic: '基本値を入力してください。',
			selectBasic: '基本値を選択してください。',
			description: '説明を入力してください。',
		},
	},

	file: {
		attachments: '添付ファイル',
		item: '個',
	},

	button: {
		cancel: 'キャンセル',
		create: '生成',
		back: '後戻り',
		modify: '修整',
		termination: 'プロジェクト終了',
		signature: '署名',
		save: '貯蔵',
		approval: '承認',
		delete: '削除',
		allDelete: '全て削除',
		history: '内訳',
		audit: '監査証跡',
		close: '閉じる',
		confirm: '確認',
		apply: '適用',
		unsign: '署名をキャンセル',
		end: '終了',
		logout: 'ログアウト',
		add: {
			schema: 'スキーマを追加する',
			text: '追加する',
			template: 'テンプレート追加',
		},
		csv: 'CSVファイルのアップロード',
		sync: '同期',
		thumbnail: 'サムネイル変更',
		checkin: 'Check-in',
		use: '使用',
		ok: 'オーケー',
		refresh: '再読み込み',
		closeAll: 'すべて閉じる',
		revoke: '解約',
		assign: '割り当て',
		renew: '更新',
	},

	sort: {
		desc: '降順',
		asc: '昇順',
		createAt: '登録日順',
	},

	project: {
		modal: {
			create: 'プロジェクトを作成する',
			modify: 'プロジェクトを変更する',
			title: 'プロジェクトタイトル',
			description: '説明',
			setParticipant: '参加者を設定する',
			priority: '重要度',
			projectLeader: 'プロジェクトリーダー',
			placeholder: {
				name: 'プロジェクト名を入力してください',
				description: 'プロジェクトの説明を入力してください',
				projectLeader: 'プロジェクトリーダーを選択してください',
				priority: '優先順位を選択してください',
			},

			departmentName: '部署名',
			err: {
				name: 'プロジェクト名を入力してください',
				duplicated: 'プロジェクト名がすでに使用されています',
			},
		},
		select: 'プロジェクトを選択してください。',
		name: 'プロジェクト名',
		description: '説明',
		department: '部署',
		participate: '参加研究員',
		setting: 'ユーザー設定',

		placeholder: {
			name: 'プロジェクト名を入力します',
			description: 'プロジェクトの説明を入力します',
		},

		templateAdd: 'テンプレート追加',

		err: {
			name: 'プロジェクト名を入力します',
		},

		create: {
			existstitle: { failure: 'プロジェクト名は既に存在します。' },
		},

		note: {
			create: 'ノート作成',
			name: 'ノート名',
			template: 'テンプレート',
			edit: 'ノート編集',
			placeholder: {
				name: 'ノートタイトルを入力してください',
				description: 'ノート説明を入力してください',
			},

			err: {
				name: 'ノート名を入力してください',
			},

			status: {
				progress: '進行中',
				reviewing: '検討中',
				pending: '保留',
				closed: '終了',
				new: '新規',
			},

			sideMenu: {
				auditTrail: 'Audit Trail',
				setting: 'プロジェクト設定',
				signNote: 'ノート署名',
				endProject: 'プロジェクトの終了',
				confirmEndProject: '終了したプロジェクトは修正できません。',
				noteSetting: 'ノート設定',
				noteCreate: 'ノート 追加',
				reopenProject: 'プロジェクトの再開',
				confirmReopenProject: '終了状態が解除され、編集できるようになります。',
			},
			signature: {
				title: '署名',
				approve: '承認',
				etc: 'メモ',
				sign: '決裁',
				load: '署名読み込み',
				request: '署名要求',
				requestAll: '全体署名要求',
				unsign: '署名解除',
				confirmSubmit: '署名を行いますか？',
				confirmAccuracy: '上記の記録が正確であることを確認し、署名します。',
				confirmReviewContent: '当該バージョンの電子ラボノートの内容を確認し、記録の漏れや誤りがないことを確認しました。',
				confirmAckRequired: '上記の項目をすべて確認してから「確認」を押してください。',
				imageUnavailable: '署名画像のパスを読み込めません。',
				noRevisionForSign: 'ノートの修正履歴がないため、署名できません。',
			},
		},

		empty: {
			add: 'ノート作成ボタンをクリックしてノートを作成してください',
			finish: '完了したプロジェクトです',
			select: 'プロジェクトを選択してください',
		},

		table: {
			name: 'テーブル',
			create: '生成',
			max: '最大',
			err: {
				create: '1個~30個まで生成できます',
			},
			alarmList: {
				create: 'テーブル内にテーブルを作成することはできません。',
				max: 'テーブルは最大30×30です。',
				lastLow: '最後の行は削除できません。',
				lastCol: '最後の列は削除できません。',
				dropbox: '作成されたドロップダウンを削除した後に、再度作成できます。',
				boxCreate: 'このセルにはドロップダウンを作成できません。',
				select: 'テーブルが選択されていません。\n もう一度お試しください。',
			},
		},
		signature: {
			complete: '署名が完了しました。 \n編集はできません\n編集が必要な場合は、プロジェクトリーダーに署名解除を依頼してください。',
			modify: ' さんが編集中です。',
			warn: 'レビューアーとして署名した人はいません。\n ノートを終了するには、少なくとも1人がレビューアーとして署名する必要があります。\n 署名を解除してレビューアーとして署名するか \n 新しいメンバーを追加してレビューアーとして署名してください。',
		},
		terminate: '現在終了したプロジェクトです。',
		admin: 'ノートを作成する権限がありません。',
	},

	sideMenu: {
		left: '左揃え',
		center: '中央整列',
		right: '右揃え',
		cut: '画像切り',
		delete: '削除',
		modifyChart: 'チャート修正',
		review: 'レビュー',
		modifyReview: 'レビュー修正',
		deleteReview: 'レビュー削除',
		blockAdd: 'ブロック追加',
	},

	context: {
		rowTitle: '対象の行を指定してください',
		columnTitle: '対象の列を指定してください',
		rowTitleRemove: 'タイトル行を解除する',
		columnTitleRemove: 'タイトル列を解除する',
		left: '左側に列を追加します',
		right: '右側に列を追加します',
		up: '行を追加します',
		down: '行を下に追加します',
		merge: 'セルマージ',
		unmerge: 'セルマージ解除',
		removeMerge: 'アンマージ セル',
		deleteCol: 'カラムを削除します',
		deleteRow: '削除行',
		dropbox: 'ドロップボックス作成',
		asset: '資産追加',
		image: '画像挿入',
		comment: '共通項目',
	},

	options: {
		header: {
			h1: '大見出し',
			h2: '中見出し',
			h3: '小見出し',
			h4: '内容',
			h5: '説明',
			h6: '参照',
		},
		bold: '太く',
		italic: '傾き',
		strikethrough: 'キャンセル線',
		underline: '下線',
		superscript: '上添字',
		subscript: '下添字',
		color: '文字色',
		bg: '文字背景',
		fontSize: 'フォントサイズ',
		fontChange: 'フォントを変更',
		add: {
			table: 'テーブル追加',
			image: 'イメージ追加',
			calendar: '日付追加',
			chart: {
				text: 'チャートを追加',
				bar: '棒グラフ',
				horizontal: '水平グラフ',
				line: '折れ線グラフ',
				doughnut: 'ドーナツチャート',
				pie: 'パイチャート',
				radar: 'レーダーチャート',
				scatter: '散布図',
				yTitle: 'y軸のラベル名',
				xTitle: 'x軸のラベル名',
			},
		},

		upload: 'ファイルアップロード',
		download: 'PDFダウンロード',
	},

	schema: {
		select: 'スキーマを選択してください。',
		titleList: {
			title: 'タイトル',
			description: '説明',
			list: 'リスト',
			type: 'タイプ',
			version: 'バージョン',
			schemaTypeCode: 'スキーマタイプコード',
			schemaTypeName: 'スキーマタイプの名前',
			new: '新しいスキーマ',
		},
		placeholderList: {
			titlePlaceholder: 'タイトルを入力してください。',
			schemaTypeCode: 'スキーマコードを入力してください。',
			schemaTypeName: 'スキーマタイプ名を入力してください。',
			description: 'スキーマの説明を入力してください。',
			schemaName: 'スキーマ名を入力してください。',
			field: 'フィールドを入力してください。',
			value: '値を入力してください。（200文字まで）',
			unique: '固有値を入力してください。',
			basic: '基本値を入力してください。',
			selectBasic: '基本値を選択してください。',
		},
		modal: {
			create: 'スキーマが作成されました。',
			modify: 'スキーマが修正されました。',
			schemaTypeCode: 'スキーマコードは必須です。',
			schemaTypeName: 'スキーマタイプ名は必須です。',
			schemaTitle: 'スキーマタイトルは必須です。',
			schemaContent: 'スキーマの内容を入力してください。',
			schemaUnique: '固有値は必須です。',
			schemaField: 'スキーマフィールドは必須です。',
			schemaValue: 'スキーマ値は必須です。',
			schemaFieldAndValue: 'スキーマのフィールドと値を入力してください。',
			schemaName: 'スキーマ名は必須です。',
			schemaLabelRequired: '名称は必須です。',
			schemaListRequired: 'スキーマリストは必須です。',
			required: '必須値を入力してください。',
			schemaDuplicate: 'スキーマタイトルはすでに使用されています。',
			schemaDropbox: 'ドロップボックスを先に作成してください。',
			schemaListType: 'スキーマタイプ名は必須です。',
			schemaDropboxDefault: 'ドロップボックスの基本値は必須です。',
		},
		radio: {
			use: '使用',
			unused: '未使用',
		},
		error: {
			unique: '固有値は重複できません。',
			maxLength: '200文字以内で入力してください。',
			maxCount: 'スキーマリストは最大50個まで作成できます。',
			blockMaxCount: 'フィールドと値は最大30個まで追加できます。',
			cannotDeleteExisting: '既存のスキーマは削除できません。',
		},
		create: {
			success: 'スキーマが作成されました。',
			server: { failure: 'スキーマ作成中にエラーが発生しました。' },
			title: { failure: 'スキーマタイトルは必須です。' },
			uniquevalue: { failure: '固有値が重複しています。' },
		},
		retrieve: { existstitle: { failure: 'スキーマタイトルは既に存在します。' } },
		save: {
			success: 'スキーマが保存されました。',
			server: { failure: 'スキーマ保存中にエラーが発生しました。' },
			uniquevalue: { failure: '固有値が重複しています。' },
		},
	},

	dropbox: {
		select: 'ドロップボックスを選択してください。',
		defaultPlaceholder: '選択してください',
		info: {
			status: '状態',
			active: 'アクティブ',
			inActive: '非アクティブ',
			version: 'バージョン',
			versionPlaceholder: 'バージョンを選択',
			title: 'タイトル',
			titlePlaceholder: 'タイトルを入力してください。',
			description: '説明',
			descriptionPlaceholder: '説明を入力してください。',
			placeHolder: 'プレースホルダー',
			placeHolderPlaceholder: 'Placeholderを入力してください',
			titleRequired: 'タイトルは必須です。',
			titleDuplicate: 'タイトルは既に使用されています。',
			save: '保存',
		},
		item: {
			list: 'リスト',
			code: 'コード',
			value: '値',
			default: 'デフォルト',
			codePlaceholder: 'コードを入力してください。',
			valuePlaceholder: '値を入力してください。',
			codeWarn: 'コードは必須です。',
			valueWarn: '値は必須です。',
			codeRequired: 'コードは必須です。',
			valueRequired: '値は必須です。',
			codeDuplicate: '2つのコードに同じ名前を付けることはできません。',
			active: 'アクティブ',
			inActive: '非アクティブ',
			create: '作成',
			status: '状態',
		},
		right: {
			noSelect: '選択された値がありません。',
			select: '左のリストを選択して詳細を確認できます。',
			active: 'アクティブ',
			inActive: '非アクティブ',
			default: 'デフォルト',
			noDefault: 'デフォルトなし',
		},
		create: {
			success: 'ドロップボックスが作成されました。',
			codeduplicate: { failure: 'コードが重複しています。' },
			existscode: { failure: 'コードは既に存在します。' },
			existstitle: { failure: 'タイトルは既に存在します。' },
			server: { failure: 'ドロップボックス作成中にエラーが発生しました。' },
		},
		save: {
			success: 'ドロップボックスが保存されました。',
			codeduplicate: { failure: 'コードが重複しています。' },
			server: { failure: 'ドロップボックス保存中にエラーが発生しました。' },
		},
		error: {
			maxLength: '200文字を超えることはできません。',
			defaultRequired: 'デフォルト値は必須です。',
		},
	},

	template: {
		modal: {
			create: 'テンプレート作成',
			modify: 'テンプレート修正',
			title: 'テンプレート名',
			description: '説明',
			templateLeader: 'テンプレートリーダー',
			templateNameRequired: 'テンプレート名を入力してください。',
			placeholder: {
				name: 'テンプレート名を入力してください。',
				description: 'テンプレートの説明を入力してください。',
				templateLeader: 'テンプレートリーダーを選択してください。',
			},
		},
		createTemplate: 'テンプレート作成',
		templateName: 'テンプレート名',
		placeholder: 'テンプレート名を入力してください。',
		warn: 'テンプレート名は必須です。',
		sideMenu: {
			auditTrail: 'Audit Trail',
			setting: '設定テンプレート',
			approve: 'テンプレートを承認する',
		},
		select: 'テンプレートを選択してください.',
		create: {
			success: 'テンプレートが作成されました。',
			existstitle: { failure: 'テンプレート名は既に存在します。' },
			server: { failure: 'テンプレート作成中にエラーが発生しました。' },
		},
	},

	admin: {
		menu: {
			project: 'Project',
			template: 'Template',
			schema: 'Schema',
			dropbox: 'Dropbox',
		},
		access: '権限',
		id: 'ID',
		name: '名前',
		number: '社員番号',
		companyName: '会社名',
		placeholder: {
			userId: 'ユーザーIDを入力してください。',
			companyName: '会社名を入力してください。',
			departmentName: '部署名を入力してください。',
			createDt: '登録日時を入力してください。',
			loginDt: '最近のログインを入力してください。',
		},
		departmentName: '部署名',
		positionName: '役職',
		email: 'Email',
		phone: '連絡先 ',
		date: '登録日時',
		loginDt: '最近のログイン',
		department: '部署',
		employees: '社員および役員',
		emailFormat: '有効なメールアドレスを入力してください。',
		role: {
			Name: '権限',
			roleDepartment: '部署 権限',
			roleList: '権限リスト',
			roleSet: '権限設定',
			roleAddDelete: '権限追加および削除',
			employeeRoleGroup: '社員権限グループ',
			createRoleGroup: '権限グループ作成',
			deleteRoleGroup: '権限グループ削除',
		},
	},

	license: {
		title: '製品ライセンス情報',
		licenseName: 'ライセンス名',
		status: 'ライセンスの状態',
		ver: 'バージョン',
		endDate: '期限',
		maxCapacity: '最大容量',
		update: '更新日',
		assign: { success: 'ライセンスが割り当てられました。' },
		revoke: { success: 'ライセンスが解除されました。' },
		count: 'ライセンス アクティブ ユーザー数',
	},

	pagination: {
		prev: '前へ',
		next: '次へ',
	},

	notFound: {
		title: 'ページが見つかりません',
		message: 'リクエストされたページが見つかりません',
		home: '家に帰れ',
	},

	userModal: {
		user: '参加者指定',
		approver: '承認者指定',
		viewer: 'ビューア指定',
		license: 'ライセンス割り当て',
	},
	asset: {
		create: 'メニューを選択してください.',
	},
	tab: {
		new: '新しいタブ',
	},

	review: {
		now: 'さっき',
		min: '分前',
		hour: '時間前',
		day: '日前',
		week: '週前',
		month: '月前',
		year: '年前',
		modify: 'コメント 修正',
		delete: 'コメント 削除',
	},

	// 監査(audit) 自然言語テンプレート
	auditText: {
		ipSuffix: ' ip({ip})',
		user: {
			update: {
				success: '{user} さんの情報が修正されました。',
			},
		},
		login: {
			success: '{user} さんがログインに成功しました。{ipSuffix}',
			failure: '{user} さんのログインに失敗しました。{ipSuffix}',
		},
		note: {
			create: '{note} ノートが作成されました。',
			save: '{note} ノートが保存されました。',
			update: '{note} ノートが修正されました。',
			closed: '{note} ノートが終了しました。',
			signature: {
				success: '{note} ノートの署名が完了しました。',
				failure: '{note} ノートの署名処理に失敗しました。',
			},
		},
		project: {
			create: '{project} プロジェクトが作成されました。',
			save: '{project} プロジェクトが保存されました。',
			update: '{project} プロジェクトが修正されました。',
			closable: '{project} プロジェクトを終了できます。',
			closed: '{project} プロジェクトが終了しました。',
			opened: '{project} プロジェクトが進行状態に変更されました。',
		},
		template: {
			create: '{template} テンプレートが作成されました。',
			save: '{template} テンプレートが保存されました。',
			update: '{template} テンプレートが修正されました。',
			approve: '{template} テンプレートが承認されました。',
			checkin: '{template} テンプレートがチェックインされました。',
			checkout: '{template} テンプレートがチェックアウトされました。',
		},
		dropbox: {
			create: '{dropbox} ドロップボックスが作成されました。',
			save: '{dropbox} ドロップボックスが保存されました。',
		},
		schema: {
			create: '{schema} スキーマが作成されました。',
			save: '{schema} スキーマが保存されました。',
		},
		license: {
			assign: '{userId} がライセンス {assignedLicenseName} を {assignedUsers} に割り当てました。',
			revoke: '{userId} がライセンス {revokedLicenseName} を {revokedUsers} から削除しました。',
		},
		department: {
			updateuser: 'ユーザー権限が保存されました。',
		},
	},

	auth: {
		login: {
			userid: {
				failure: 'ログイン失敗',
			},
			success: 'ログイン成功',
			failure: 'ログインに失敗しました。',
			password: { failure: 'パスワードが一致しません。' },
		},
		logout: {
			success: 'ログアウト成功',
			confirm: 'ログアウトしますか？',
			failure: 'ログアウトに失敗しました。 もう一度お試しください。',
		},
	},

	mypage: {
		retrieve: {
			success: 'マイページ情報取得成功',
		},
	},

	ai: {
		title: 'AIアシスタント',
		model: 'モデル',
		apiKey: 'APIキー',
		apiKeyPlaceholder: 'Gemini APIキーを入力してください',
		inputPlaceholder: 'メッセージを入力... (Enterで送信)',
		send: '送信',
		clear: 'クリア',
		empty: 'AIアシスタントとの会話を始めましょう。',
		ollamaNoModels: 'モデルが見つかりません',
		includeEditor: 'エディタの内容を含める',
		analyze: 'エディタを分析',
		analyzePrompt: '上記の内容を要約して分析してください。',
		copy: 'コピー',
		copied: 'コピー済み!',
	},
}
